import apiService from '../apiService'

const apiPath = '/report'

export const reportController = (configService) => {
	const service = apiService(configService)
	return {
		getHistory: (params) => {
			const { startDate, endDate } = params
			return service.get({
				url: `${apiPath}/get-history-report-vif?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getDailyReport: ({ startDate, endDate }) => {
			return service.get({
				url: `${apiPath}/get-daily-report-vif?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getDailyCancelReport: ({ startDate, endDate }) => {
			return service.get({
				url: `${apiPath}/get-daily-cancel-report-vif?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		downloadDailyReport: (params) => {
			const { startDate, endDate } = params
			return service.get({
				url: `${apiPath}/download-daily-report-vif?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getPaymentReportVIF: (params) => {
			const {
				startDate = '',
				endDate = '',
				statusF = '',
				searchType = 'date',
				searchValue = '',
			} = params
			const query = new URLSearchParams({
				startDate,
				endDate,
				statusFilter: statusF,
				searchType,
				searchValue,
			})
			return service.get({
				url: `${apiPath}/payment-report-vif?${query}`,
			})
		},
		getOutstandingBalance: (date) => {
			return service.get({
				url: `${apiPath}/outstandingBalance-report-vif?date=${date}`,
			})
		},
		getReceivables: (params) => {
			const { startDate, endDate, statusF, cuscode } = params
			return service.get({
				url: `${apiPath}/get-receivables-report-vif?startDate=${startDate}&endDate=${endDate}&statusFilter=${statusF}&cuscodeFilter=${
					cuscode || ''
				}`,
			})
		},
		getBillReportVIF: (startDate) => {
			return service.get({
				url: `${apiPath}/get-bills-report-vif?date=${startDate}`,
			})
		},
		getAgingReportVif: (date) => {
			return service.get({
				url: `${apiPath}/get-aging-report-vif?date=${date}`,
			})
		},
		getSalesPrbInsVif: (params) => {
			const { startDate, endDate, company, type, channel, level } = params
			return service.get({
				url: `${apiPath}/get-sales-prb-ins-vif?startDate=${startDate}&endDate=${endDate}&type=${type}&company=${company}&channel=${channel}&level=${level}`,
			})
		},
		getUserVif: () => {
			return service.get({
				url: `${apiPath}/get-user-vif`,
			})
		},
		getSellList: (params) => {
			const { startDate, endDate, company, type = 'isAll', searchType = 'date', searchValue = '', page = 1, pageSize = 50 } = params
			const query = new URLSearchParams({
				startDate: startDate || '',
				endDate: endDate || '',
				company: company || '',
				type,
				searchType,
				searchValue,
				page,
				pageSize,
			})
			return service.get({
				url: `${apiPath}/get_SellList?${query}`,
			})
		},
		getSaleCancelVif: (params) => {
			const { startDate, endDate, company, type = 'isAll', searchType = 'date', searchValue = '', page = 1, pageSize = 50 } = params
			const query = new URLSearchParams({
				startDate: startDate || '',
				endDate: endDate || '',
				company: company || '',
				type,
				searchType,
				searchValue,
				page,
				pageSize,
			})
			return service.get({
				url: `${apiPath}/get_SaleCancelVif?${query}`,
			})
		},
		getDownLineSaleReport: (params) => {
			const { startDate, endDate } = params
			return service.get({
				url: `${apiPath}/get-DownLine-SaleReport?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getReportNonActive: (params) => {
			const { startDate, endDate, channel } = params
			return service.get({
				url: `${apiPath}/get-report-non-active?startDate=${startDate}&endDate=${endDate}&channel=${channel}`,
			})
		},
		getReportClassifyDebitCredit: (params) => {
			const { startDate, endDate } = params
			return service.get({
				url: `${apiPath}/get-report-classify-debit-credit?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getReportSalesYears: (years) => {
			return service.get({
				url: `${apiPath}/get-report-sales-years?years=${years}`,
			})
		},
		getReportDebit: () => {
			return service.get({
				url: `${apiPath}/get-report-debit`,
			})
		},
		getReportDebitAdmin: (params) => {
			const {
				searchType = 'date',
				searchValue = '',
				startDate = '',
				endDate = '',
				amount = '',
				page = 1,
				pageSize = 20,
			} = params
			const query = new URLSearchParams({
				searchType,
				searchValue,
				startDate,
				endDate,
				amount,
				page,
				pageSize,
			})
			return service.get({
				url: `${apiPath}/get-report-debit-admin?${query}`,
			})
		},
		getCreditBalanceReport: (params) => {
			const {
				searchType = 'date',
				searchValue = '',
				startDate = '',
				endDate = '',
				page = 1,
				pageSize = 20,
			} = params
			const query = new URLSearchParams({
				searchType,
				searchValue,
				startDate,
				endDate,
				page,
				pageSize,
			})
			return service.get({
				url: `${apiPath}/get-credit-balance-report-vif?${query}`,
			})
		},
		getCancelSlipStatementReport: (params) => {
			const {
				searchType = 'date',
				searchValue = '',
				startDate = '',
				endDate = '',
				statusF = '',
				page = 1,
				pageSize = 20,
			} = params
			const query = new URLSearchParams({
				searchType,
				searchValue,
				startDate,
				endDate,
				statusFilter: statusF,
				page,
				pageSize,
			})
			return service.get({
				url: `${apiPath}/get-cancel-slip-statement-report-vif?${query}`,
			})
		},
		getDetailReportDebitAdmin: (params) => {
			const { cuscode, startDate, endDate } = params
			return service.get({
				url: `${apiPath}/get-detail-report-debit-admin?cuscode=${cuscode}&startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getDetailBillHistory: (params) => {
			const { start, end, id_cus } = params
			return service.get({
				url: `${apiPath}/get-detail-bill-history?startDate=${start}&endDate=${end}&id_cus=${id_cus}`,
			})
		},
		getDetailBillDaily: (params) => {
			const { start, end, id_cus } = params
			return service.get({
				url: `${apiPath}/get-detail-bill-daily?startDate=${start}&endDate=${end}&id_cus=${id_cus}`,
			})
		},
		getBillDailyAccount: (params) => {
			const { start, end } = params
			return service.get({
				url: `${apiPath}/get-bill-daily-account?startDate=${start}&endDate=${end}`,
			})
		},
		getDetailFileHistory: (bill_num) => {
			return service.get({
				url: `${apiPath}/get-detail-File-history?bill_num=${bill_num}`,
			})
		},
		getUploadSlipBill: () => {
			return service.get({
				url: `${apiPath}/get-upload-slip-bill`,
			})
		},
		getCheckSlipBill: (params) => {
			const { start, end } = params
			return service.get({
				url: `${apiPath}/get-check-slip-bill?startDate=${start}&endDate=${end}`,
			})
		},
		getDetailSlipBill: (inv_no) => {
			return service.get({
				url: `${apiPath}/get-detail-slip-bill?invNo=${inv_no}`,
			})
		},
		getPriceRenewKumpai: () => {
			return service.get({
				url: `${apiPath}/get-price_renew_kumpai`,
			})
		},
		getInsuranceOlds: (params) => {
			const { search, chanel } = params
			return service.get({
				url: `${apiPath}/get-insurance-olds?search=${search}&chanel=${chanel}`,
			})
		},
		getDetailBillAccount: (params) => {
			const { start, end } = params
			return service.get({
				url: `${apiPath}/get-detail-bill-cancel-admin?startDate=${start}&endDate=${end}`,
			})
		},
		getOverdueReportVIF: (mySearch) => {
			return service.get({
				url: `${apiPath}/overdue-report-vif?mySearch=${mySearch}`,
			})
		},
		getTaxDailyReport: (params) => {
			const { startDate, endDate } = params
			return service.get({
				url: `${apiPath}/get-tax-daily?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getLogErrorAccount: (params) => {
			const { startDate, endDate } = params
			return service.get({
				url: `${apiPath}/get_log_error_account?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getReportTax: () => {
			return service.get({
				url: `${apiPath}/get_report_taxs`,
			})
		},
		getReportOrderTax: (status, date) => {
			return service.get({
				url: `${apiPath}/get_report_order_taxs?status=${status}&date=${date}`,
			})
		},
		getPdfOrderTaxs: (params) => {
			return service.post({
				url: `${apiPath}/get_pdf_order_tax`,
				body: params,
			})
		},
		getReportReturnCredit: (params) => {
			const { startDate, endDate } = params
			return service.get({
				url: `${apiPath}/get-report-return-credit?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getBillFollowOsdBalanceVIF: () => {
			return service.get({
				url: `${apiPath}/get-bills-Follow-OsdBalance`,
			})
		},
		getCreditVifReturnAdmin: (params) => {
			const { startDate, endDate, statusF } = params
			return service.get({
				url: `${apiPath}/get-return-credit-vif-admin?startDate=${startDate}&endDate=${endDate}&statusF=${statusF}`,
			})
		},
		getMatchListDebit: (params) => {
			return service.post({
				url: `${apiPath}/get-match-list-debit`,
				body: params,
			})
		},
		getMatchDebitDetail: (params) => {
			return service.post({
				url: `${apiPath}/get-match-debit-detail`,
				body: params,
			})
		},
		exportExcelMatchListDebit: () => {
			return service.post({
				url: `${apiPath}/export-excel-match-list-debit`,
				body: {},
			})
		},
		getEndorseReport: ({ startDate, endDate }) => {
			return service.get({
				url: `${apiPath}/get-endorse-report?startDate=${startDate}&endDate=${endDate}`,
			})
		},
		getEndorseDetailReport: (endorse_no) => {
			return service.get({
				url: `${apiPath}/get-endorse-detail-report?endorse_no=${endorse_no}`,
			})
		},
		getEndorseDetailFileReport: (endorse_no) => {
			return service.get({
				url: `${apiPath}/get-endorse-detail-file-report?endorse_no=${endorse_no}`,
			})
		},
		getEndorseByAdminReport: ({ startDate, endDate, search }) => {
			return service.get({
				url: `${apiPath}/get-endorse-by-admin-report?startDate=${startDate}&endDate=${endDate}&search=${search}`,
			})
		},
		getEndorseAccountReport: ({ startDate, endDate, searchType, searchValue, status, page, pageSize }) => {
			return service.get({
				url: `${apiPath}/get-endorse-account-report?startDate=${startDate}&endDate=${endDate}&searchType=${searchType}&searchValue=${searchValue}&status=${status}&page=${page}&pageSize=${pageSize}`,
			})
		},
		getEndorseAddMoneyReport: ({ startDate, endDate, searchType, searchValue, status, page, pageSize }) => {
			return service.get({
				url: `${apiPath}/get-endorse-add-money-report-vif?startDate=${startDate}&endDate=${endDate}&searchType=${searchType}&searchValue=${searchValue}&status=${status}&page=${page}&pageSize=${pageSize}`,
			})
		},
		getDetailBillDailyToVertical: ({ start, end }) => {
			return service.post({
				url: `${apiPath}/get-detail-bill-daily-to-vertical`,
				body: { startDate: start, endDate: end },
			})
		},
		getCustomerHistory: (search) => {
			return service.post({
				url: `${apiPath}/get-customer-history-vif`,
				body: { search },
			})
		},
		getWaitDuppJobs: (search) => {
			return service.post({
				url: `${apiPath}/get-wait-dupp-jobs`,
				body: { search },
			})
		},
		getDuppPolicy: (params) => {
			return service.post({
				url: `${apiPath}/get-dupp-policy`,
				body: params,
			})
		},
	}
}
